import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import {
  ColorLabels,
  useInvertedColor,
} from "@/components/editor/utils/use-color";

export const EventName = styled.span`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  line-height: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  overflow: hidden;
  text-overflow: ellipsis;
  height: min-content;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  margin-bottom: 0.5rem;
  -webkit-box-orient: vertical;
`;

export const EventTime = styled.span`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY_FONT]};
  font-size: 12px;
  line-height: 16px;
`;

export const EventTimezone = styled.span`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY_FONT]};
  font-size: 12px;
  line-height: 16px;
  opacity: 0.7;
`;

export const EventDescription = styled.p`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  line-height: 26px;
  font-weight: 300;
  color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY_FONT]};
  overflow: hidden;
  text-overflow: ellipsis;
  height: min-content;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const Container = withViewportStyle("div")`
  display: flex;
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  flex-direction: column;
  flex: 1;
  padding: 24px;
  border-radius: 12px;
  border: 2px solid ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  background-color: ${({ theme }) =>
    useInvertedColor(theme.colors[ColorLabels.BACKGROUND]) === "#000000"
      ? "#fff"
      : theme.colors[ColorLabels.BACKGROUND]};

  ${(props) => props.$viewport.tablet`
    flex: unset;
  `}
`;

export const NoEventCardContainer = withViewportStyle("div")`
  flex: 1;
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  padding: 24px;
  border-radius: 12px;
  border: 2px solid ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  background-color: ${({ theme }) =>
    useInvertedColor(theme.colors[ColorLabels.BACKGROUND]) === "#000000"
      ? "#fff"
      : theme.colors[ColorLabels.BACKGROUND]};
`;

export const Logo = styled.div<{
  image: string;
}>`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${({ image }) => image});
  aspect-ratio: 1.5;
  width: 96px;
  border-radius: 12px;
`;

export const RegisterButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: auto;
`;

export const RegisterButton = styled.button`
  font-size: ${rem(16)};
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  font-weight: 700;
  line-height: ${rem(28)};
  cursor: pointer;
  padding: ${rem(8)} ${rem(40)};
  justify-content: center;
  align-items: center;
  border-radius: ${rem(200)};
  background-color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
  color: ${({ theme }) => useInvertedColor(theme.colors[ColorLabels.PRIMARY])};
  border: 2px solid ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
`;
